import React from 'react'
import { Input } from '../ui/Input'
import { Label } from '../ui/label'
import { cn } from '@/lib/utils'

interface CnhInputProps {
 value: string
 onChange: (value: string) => void
 placeholder?: string
 className?: string
 label?: string
 required?: boolean
}

export const CnhInput: React.FC<CnhInputProps> = ({
 value,
 onChange,
 placeholder = '00000000000',
 className,
 label = 'CNH',
 required = false
}) => {
 const formatCnh = (input: string): string => {
 // Remove tudo que não é número
 const numbers = input.replace(/\D/g, '')
 // Limita a 11 dígitos
 return numbers.slice(0, 11)
 }

 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
 const formatted = formatCnh(e.target.value)
 onChange(formatted)
 }

 return (
 <div className={cn('space-y-2', className)}>
 {label && (
 <Label>
 {label}
 {required && <span className="text-destructive ml-1">*</span>}
 </Label>
 )}
 <Input
 type="text"
 value={value}
 onChange={handleChange}
 placeholder={placeholder}
 maxLength={11}
 />
 </div>
 )
}

